// extracted by mini-css-extract-plugin
export default {"container":"Countdown_container__NZZvm","pulse":"Countdown_pulse__NxHM2"};